import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme: { spacing, border, color } }) => css`
    display: flex;
    justify-content: space-between;
    max-height: 141px;
    width: 100%;
    padding: ${spacing.km6} ${spacing.km8};
    margin-top: auto;
    border-top: ${border.width.thinner} ${border.style.solid}
      ${color.border.neutral.default};

    @media (min-width: 769px) {
      align-items: right;
    }

    @media (max-width: 768px) {
      flex-direction: column;
      justify-content: right;
    }
  `}
`;

export const Content = styled.div`
  ${({ theme: { spacing } }) => css`
    display: flex;
    width: 100%;
    gap: ${spacing.km3};
    justify-content: flex-end;

    @media (min-width: 769px) {
      margin-right: ${spacing.km4};
    }

    @media (max-width: 768px) {
      margin-bottom: ${spacing.km6};
    }
  `}
`;

export const ButtonsBox = styled.div`
  display: flex;
  align-items: right;
  width: fit-content;

  @media (min-width: 769px) {
    margin-left: auto;
  }

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
  }
`;
